// extracted by mini-css-extract-plugin
export default {"home":"GroupMenu_home__pjWC5","card":"GroupMenu_card__KpDK7","member":"GroupMenu_member__itMcm","submitButton":"GroupMenu_submitButton__iQb5Q"};